// extracted by mini-css-extract-plugin
var _1 = "FileUpload-module__body___XOp2f";
var _2 = "FileUpload-module__content___xNQd0";
var _3 = "FileUpload-module__fileDetails___O89Ad";
var _4 = "FileUpload-module__fileName___WXJkc";
var _5 = "FileUpload-module__fileUploadWrapper___mShNQ";
var _6 = "FileUpload-module__hidden___leG7z";
export { _1 as "body", _2 as "content", _3 as "fileDetails", _4 as "fileName", _5 as "fileUploadWrapper", _6 as "hidden" }
